import $ from 'jquery';
import 'jquery-validation';

$(function() {
    const $modal = $('#private_comment_modal')
    const $form= $modal.find<HTMLFormElement>('form#private_comment_client_modal')
    const $textarea = $form.find<HTMLTextAreaElement>('textarea.charCounters-textarea')

    const minLen = parseInt($textarea.attr('minlength') || '15', 10)
    const maxLen = parseInt($textarea.attr('maxlength') || '250', 10)

    // Initialize the validator
    $form.validate({
        rules: {
            private_comment_client: {
                required: true,
                minlength: minLen,
                maxlength: maxLen
            }
        },
        messages: {
            private_comment_client: {
                required: $textarea.data('msg-required')  as string,
                minlength: $textarea.data('msg-minlength') as string,
                maxlength: $textarea.data('msg-maxlength') as string
            }
        },
        errorClass: 'invalid-feedback',
        errorElement: 'div',
        errorLabelContainer: '.private_comment_client-error',
        wrapper:             'div',
        errorPlacement(error, element) {
            $form.find('.private_comment_client-error').html(error).show();
        },
        success(label, element) {
            $form.find('.private_comment_client-error').empty().hide();
        },
        submitHandler(formEl) {
            const $btn = $form.find<HTMLButtonElement>('button[type="submit"]')
            $btn.prop('disabled', true)

            $.ajax({
                url: $form.attr('action'),
                method: ($form.attr('method') as string) || 'POST',
                data: $form.serialize(),
                dataType: 'script',
                success(_data) {
                    $('.private_comment_modal_cta').addClass('d-none')
                    $form.find<HTMLButtonElement>('[data-bs-dismiss="modal"]').trigger('click')
                    $('html, body').animate({ scrollTop: 0 }, 'fast');
                    $('#private_comment_modal_success').removeClass('d-none')
                    setTimeout(() => {
                        $('#private_comment_modal_success').addClass('show');
                    }, 750);
                },
                error(xhr) {
                    let msg = $textarea.data('msg-general')  as string
                    if (xhr.responseJSON?.error) {
                        msg = xhr.responseJSON.error
                    }
                    $form.find('.private_comment_client-error').text(msg).show();
                },
                complete() {
                    $btn.prop('disabled', false)
                }
            })

            return false // prevent normal submit
        }
    })
});
